var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time-picker-modal',{attrs:{"init-hour":_vm.hour,"init-minute":_vm.minute,"init-selected":_vm.periodSelected,"handle-hour-change":_vm.handleHourChange,"handle-minute-change":_vm.handleMinuteChange,"handle-time-change":_vm.handleTimeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }